export default "__VITE_ASSET__59cd3ebd__"